import { render, staticRenderFns } from "./render-commission-status-column-value.vue?vue&type=template&id=cd4ed494"
import script from "./render-commission-status-column-value.vue?vue&type=script&lang=js"
export * from "./render-commission-status-column-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd4ed494')) {
      api.createRecord('cd4ed494', component.options)
    } else {
      api.reload('cd4ed494', component.options)
    }
    module.hot.accept("./render-commission-status-column-value.vue?vue&type=template&id=cd4ed494", function () {
      api.rerender('cd4ed494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/comission/components/render-commission-status-column-value.vue"
export default component.exports